module.exports = __webpack_public_path__ + "assets/img/12-1.3840a8be.png";